import Dexie, { Table } from "dexie";

export interface FundHistory {
  fundId: string;
  endDate: number;
  startDate: number;
  lastUpdate: number;
  values: number[];
  isGestSep: boolean;
}
export type FundListType = "it_en_dc" | "it_en_iis";
export interface FundIdList {
  listType: FundListType;
  ids: string[];
  lastUpdate: number;
}

export class FundHistoryDexie extends Dexie {
  histories!: Table<FundHistory, string>;
  fundLists!: Table<FundIdList, FundListType>;
  constructor() {
    super("EmpirichDatas");
    this.version(2).stores({
      histories: "fundId, endDate, startDate, lastUpdate, isGestSep", // Primary key and indexed props
      fundLists: "listType, lastUpdate",
    });
  }
}

function initDb() {
  void Dexie.delete("Empirich").catch((error) => {
    console.warn("Impossibile eliminare il vecchio database Empirich", error);
  });

  return new FundHistoryDexie();
}

export const db = initDb();
